let prefix_local_options = `${APIPrefix.get()}/api/mhp/optionsandchoices`;
let prefix_local_hotspots = `${APIPrefix.get()}/api/mhp/optionsandchoices/option`;

const PAGE_OPTIONS_AND_CHOICES = document.querySelector(
  "#pageoptionsandchoices"
);

if (PAGE_OPTIONS_AND_CHOICES) {
  const getOptionsAndChoices = async (params) => {
    let previewMode = "";
    if (params.pageMode) {
      previewMode = previewMode + `&pageMode=${params.pageMode}`;
      if (params.type) {
        previewMode = previewMode + `&settype=${params.type}`;
      }
    }
    if (params.schemeId) {
      previewMode = previewMode + `&setid=${params.schemeId}`;
    }

    let response;
    response = await fetch(
      `${prefix_local_options}?sitecode=${params.sitecode}&plotcode=${params.plotcode}&language=${params.language}${previewMode}`
    );
    if (response.status == 200) {
      let data = await response.json();
      if (data.status === '401') {
        APIUtils.redirectUserToSigninPage();
      } else {
        return data;
      }
    } else {
      showErrorMessageOptions();
      return false;
    }
  };

  const showErrorMessageOptions = () => {
    let msg = document.querySelector(".rest-message--fail").value ? document.querySelector(".rest-message--fail").value : "";
    jQuery("#pageoptionsandchoices-select").hide();
    jQuery("#thank-you-page").hide();
    jQuery("#pageoptionsandchoices").hide();
    jQuery("#error-msg").append(`<p>${msg}`);
  };

  const confirmSelection = async function (param, data) {
    let previewMode = "";
    if (param.setid) {
      previewMode = previewMode + `&setid=${param.setid}`;
    }
    if (param.pageMode) {
      previewMode = previewMode + `&pageMode=${param.pageMode}`;
    }

    let urlPostSelection = `${prefix_local_options}?sitecode=${param.sitecode}&plotcode=${param.plotcode}&language=${param.language}&settype=${param.type}&isConfirmed=${param.isConfirmed}${previewMode}`;
    let response;
    response = await fetch(urlPostSelection, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.status == 200) {
      let data = await response.json();
      if (data.status === "401") {
        APIUtils.redirectUserToSigninPage();
      } else {
        return data;
      }
    } else {
      showErrorMessageOptions();
      return false;
    }
  };

  const submitSelection = (e) => {
    e.preventDefault();

    jQuery(".data-failure").remove();
    let href = e.currentTarget.getAttribute("href");
    let dataObj = {};
    let urlBtn = new URL(`https://example.com${href}`);

    let setId = document.querySelector(
      '[data-id="optionsAndChoicesSetId"]'
    ).value;
    let prepareParams = {};
    prepareParams.type = urlBtn.searchParams.get("settype");

    if (prepareParams.type === "style") {
      dataObj = {
        styleId: +jQuery("input[name='styleID']:checked").val(),
        styleSetId: +setId,
        categoryId: 0,
        optionId: 0,
      };
    } else {
      dataObj = {
        categorySetId: +setId,
        categoryId: 0,
        optionId: 0,
      };
    }

    if (urlBtn.searchParams.get("pageMode")) {
      prepareParams.pageMode = urlBtn.searchParams.get("pageMode");
      dataObj.pageMode = urlBtn.searchParams.get("pageMode");
      dataObj.sendConfirmationEmail = jQuery("#sendConfirmationEmail").prop("checked") ? 0 : 1;
    }
    if (urlBtn.searchParams.get("setid")) {
      prepareParams.setid = urlBtn.searchParams.get("setid");
      dataObj.setid = urlBtn.searchParams.get("setid");
    }

    prepareParams.isConfirmed = +urlBtn.searchParams.get("isConfirmed");
    let params = getParamsFromDomAndMerge(prepareParams);

    if (e.currentTarget.className.includes("button--disabled") === false) {
      jQuery(".confirm_btn, .draft_btn").addClass("button--disabled");
      confirmSelection(params, dataObj).then((data) => {
        if (data.status === "success") {
          if (params.isConfirmed) {
            jQuery("#pageoptionsandchoices").hide();
            jQuery(".bgmodalclose").trigger("click");
            jQuery("#thank-you-page").show();
          } else {
            redirectAfterSubmit(params);
          }
        } else {
          jQuery("#schemePopUp .modal-footer").append(
            `<p class="data-failure text-left color--primary">${data.message}</p>`
          );
          jQuery(".confirm_btn, .draft_btn").removeClass("button--disabled");
        }
      });
    }
  };

  const redirectAfterSubmit = (params) => {
    let previewMode = "";
    if (params.pageMode) {
      previewMode = previewMode + `&pageMode=${params.pageMode}`;
      if (params.type) {
        previewMode = previewMode + `&settype=${params.type}`;
      }
    }
    if (params.setid) {
      previewMode = previewMode + `&setid=${params.setid}`;
    }
    window.location =
      window.location.origin +
      window.location.pathname +
      `?sitecode=${params.sitecode}&plotcode=${params.plotcode}${previewMode}`;
  };

  const submitOptions = (e) => {
    e.preventDefault();
    jQuery(".data-failure").remove();
    let dataObj = {};
    let urlBtnParam = new URL(window.location);

    let optionId = jQuery("input[data-opt-selected='true']").val();
    let prepareParams = {};
    prepareParams.type = urlBtnParam.searchParams.get("settype");

    if (prepareParams.type === "style") {
      dataObj = {
        styleId: +urlBtnParam.searchParams.get("styleId"),
        styleSetId: +urlBtnParam.searchParams.get("styleSetId"),
      };
    } else {
      dataObj = {
        categorySetId: +urlBtnParam.searchParams.get("categorySetId"),
      };
    }

    dataObj.optionId = +optionId;
    dataObj.categoryId = +urlBtnParam.searchParams.get("schemeId");
    prepareParams.isConfirmed = 0;

    if (urlBtnParam.searchParams.get("pageMode")) {
      prepareParams.pageMode = urlBtnParam.searchParams.get("pageMode");
      dataObj.pageMode = urlBtnParam.searchParams.get("pageMode");
    }
    if (urlBtnParam.searchParams.get("setid")) {
      prepareParams.setid = urlBtnParam.searchParams.get("setid");
      dataObj.setid = urlBtnParam.searchParams.get("setid");
    }

    let params = getParamsFromDomAndMerge(prepareParams);

    if (e.currentTarget.className.includes("button--disabled") === false) {
      jQuery("#save_selection_desktop, #save_selection_mobile").addClass(
        "button--disabled"
      );
      confirmSelection(params, dataObj).then((data) => {
        if (data.status === "success") {
          redirectAfterSubmit(params);
        } else {
          jQuery(
            "#options-button-accordion, #options-button-accordion-mobile"
          ).append(
            `<p class="data-failure text-left color--primary">${data.message}</p>`
          );
          jQuery("#save_selection_desktop, #save_selection_mobile").removeClass(
            "button--disabled"
          );
        }
      });
    }
  };

  const getParamsFromDomAndMerge = (params = {}) => {
    let domParams = {};
    domParams.sitecode = document.querySelector(
      '[data-id="optionsAndChoicesSiteCode"]'
    ).value;
    domParams.plotcode = document.querySelector(
      '[data-id="optionsAndChoicesPlotCode"]'
    ).value;
    domParams.language = document.querySelector(
      '[data-id="optionsAndChoicesLang"]'
    ).value;
    return { ...params, ...domParams };
  };

  const getOptionStyle = async (params, schemeId, type) => {
    let urlEndpoint = `${prefix_local_hotspots}?sitecode=${params.sitecode}&plotcode=${params.plotcode}&language=${params.language}&settype=${type}&schemeId=${schemeId}`;
    if (params.pageMode) {
      urlEndpoint = `${prefix_local_hotspots}?sitecode=${params.sitecode}&plotcode=${params.plotcode}&language=${params.language}&settype=${type}&schemeId=${schemeId}&setid=${params.schemeId}&pageMode=${params.pageMode}`;
    }
    let response;
    response = await fetch(`${urlEndpoint}`);
    if (response.status == 200) {
      let data = await response.json();
      if (data.status === "401") {
        APIUtils.redirectUserToSigninPage();
      } else {
        return data;
      }
    } else {
      showErrorMessageOptions();
      return false;
    }
  };

  var options_logical = options_logical || {};

  let custom_styles = [];

  const checkSubmitted = (showChoicesSubmitted) => {
    return showChoicesSubmitted ? true : false;
  };

  const checkSalesConfirmed = (salesConfirmed) => {
    return salesConfirmed ? true : false;
  };

  const checkStyle = (dataType) => {
    return dataType === "styles" ? true : false;
  };

  const addListenToStyle = (id) => {
    jQuery(`#style${id}`).on("change", (ev) => {
      let currentStyleSelected = ev.currentTarget.value;
      checkOptionsExist(
        custom_styles[currentStyleSelected],
        currentStyleSelected
      );
    });
  };

  const changeStyleSelected = (id) => {
    jQuery(".container-option-images").hide();
    jQuery(`#wrapper-opt-${id}`).show();
  };

  const checkOptionsExist = (options, id) => {
    if (jQuery(`#wrapper-opt-${id}`).length > 0) {
      changeStyleSelected(id);
    } else {
      jQuery(".wrapper-options").append(`
                <div class="container-option-images" id="wrapper-opt-${id}"></div>
            `);
      renderOptions(options, id);
    }
  };

  const renderOptions = (options, id) => {
    options.forEach((option) => {
      jQuery(`#wrapper-opt-${id}`).append(`
        <div class="item-option-col">
            <a tabindex="0" id="option-view-${option.id}" data-action="${option.buttonAction}" title="${option.buttonTooltip}">
                <div class="image-wrapper">
                <img
                    src="${option.image}"
                    class="img--responsive"
                    alt="${option.title}"
                >
                <p class="optionsViewButton">
                    <span tabindex="0" class="button button--theme">${option.buttonText}</span>
                </p>
                </div>
            </a>
            <p class="optionsRoom">${option.title}</p>
            <p class="optionsCurrentlySelected">${option.selectionText}</span></p>
        </div>
      `);
      addListenToBtn(`#option-view-${option.id}`);
    });
  };

  const checkOptionsActive = (showInfoWithOptionsActive) => {
    return showInfoWithOptionsActive ? true : false;
  };

  const betweenCheck = (x, min, max) => {
    return x >= min && x <= max;
  };

  const renderHotspotsAndGlosary = (options) => {
    options.forEach((feature, id) => {
      feature.forEach((hotspot, ind) => {
        hotspot.position = "right";

        if (betweenCheck(hotspot.positionX, 60, 100)) {
          hotspot.position = "left";
        }

        if (betweenCheck(hotspot.positionY, 0, 20)) {
          hotspot.position = "bottom";
        }

        if (betweenCheck(hotspot.positionY, 70, 100)) {
          hotspot.position = "top";
        }

        jQuery(`#features${id} .optionHotSpot`).append(`
                <li>
                <span
                    tabindex="0"
                    class="hotSpot
                    position-absolute
                    d-inline-block
                    text-center text-white"
                    data-x="${hotspot.positionX}"
                    data-y="${hotspot.positionY}"
                    title="${hotspot.toolTipTitle}"
                    data-position="${hotspot.position}"
                    >${ind + 1}
                </span>
                <div class="arrowleft captionHotSpot infoPanel">
                    <div class="leftPanel">
                    <h3>${hotspot.title}</h3>

                    <p>${hotspot.description}</p>
                    </div>

                    <div class="rightPanel">
                    <img
                        src="${hotspot.image}"
                    >
                    </div>
                </div>
                </li>
            `);
        jQuery(`#features${id} .viewDescription`).append(`
                <li class="d-block pt-2 pr-2 pb-1 pl-3">
                    <p class="d-inline-block">${ind + 1} - ${
          hotspot.title
        } :</p>
                    <span class="d-inline-block text-left"
                      >${hotspot.description}</span
                    >
                </li>
            `);
      });
    });
  };

  const getViewData = (params, schemeId, type) => {
    jQuery(".loader-init").append("<div class='list-loader'></div>");
    jQuery(".schemeSelectorPanel").removeClass("d-lg-block");

    let custom_options = [];
    getOptionStyle(params, schemeId, type).then((data) => {
      if (data) {
        jQuery(".loader-init .list-loader").hide();
        jQuery(".schemeSelectorPanel").addClass("d-lg-block");

        if (data.status === "success") {
          let optionsData = data.data;

          let isOptionsActive = checkOptionsActive(
            optionsData.showInfoWithOptionsActive
          );

          jQuery(".loader-init p").append(optionsData.description);
          jQuery(".option-title h2").text(optionsData.title);
          jQuery(".backActionUrl")
            .attr("href", optionsData.backButtonAction)
            .attr("title", optionsData.backButtonTooltip);
          jQuery(".viewRoomScheme").attr("src", optionsData.image);

          let selectedOption = {};

          optionsData.options.forEach((option, i) => {
            if (option.selected) selectedOption = option;
          });

          if (isOptionsActive) {
            jQuery(".showInfoWithOptionsActive").show();
            jQuery(".showInfoSelected").hide();
            optionsData.options.forEach((option, i) => {
              jQuery("#hotspot-options ul").append(`
                        <li class="">
                            <div class="custom-control custom-radio">
                            <label class="form--radio">
                              <input id="option${
                                option.id
                              }" type="radio" name="optionID" value="${
                option.id
              }" ${
                option.selected ? "data-opt-selected='true'" : "data-opt-selected='false'"
              }>
                                <span class="checkmark-option">${
                                  option.selected ? "<span class='checked-option'></span>" : ""
                                }</span>${option.title}
                            </label>
                            </div>
                        </li>
                    `);
              jQuery("#pageoptionsandchoices-select .optionsStyleSelect .row")
                .append(`
                            <li class="col-md-4">
                            <div class="custom-control custom-radio">
                            <label class="form--radio">
                              <input id="moption${
                                option.id
                              }" type="radio" name="moptionID" value="${
                option.id
              }" ${
                option.selected ? "data-opt-selected='true'" : "data-opt-selected='false'"
              }>
                              <span class="checkmark-option">${
                                option.selected ? "<span class='checked-option'></span>" : ""
                              }</span>${option.title}
                            </label>
                            </div>
                        </li>
                    `);
              jQuery(".features-wrapper").append(`
                        <div id="features${option.id}" class="feature-container">
                            <div class="viewImage position-relative">
                                <img src="${option.image}" class="image-map-image viewRoomScheme">
                                <ul class="optionHotSpot list-unstyled d-block">
                                </ul>
                            </div>
                            <div class="viewGlossary">
                                <h2>
                                ${option.title} - ${optionsData.roomTitle}
                                </h2>
                                <ul class="list-unstyled viewDescription my-3">
                                </ul>
                            </div>
                        </div>
                    `);
              custom_options[option.id] = option.features;
            });
            renderHotspotsAndGlosary(custom_options);
            jQuery(".feature-container").addClass("d-none");
            jQuery(`#features${selectedOption.id}`).removeClass("d-none");
            jQuery("#moption" + selectedOption.id).prop("checked", true);
            jQuery("#option" + selectedOption.id).prop("checked", true);
          } else {
            jQuery(".showInfoWithOptionsActive").hide();
            jQuery(".features-wrapper").append(`
                        <div id="features${selectedOption.id}" class="feature-container">
                            <div class="viewImage position-relative">
                                <img src="${selectedOption.image}" class="image-map-image viewRoomScheme">
                                <ul class="optionHotSpot list-unstyled d-block">
                                </ul>
                            </div>
                            <div class="viewGlossary">
                                <h2>
                                ${selectedOption.title} - ${optionsData.roomTitle}
                                </h2>
                                <ul class="list-unstyled viewDescription my-3">
                                </ul>
                            </div>
                        </div>
                    `);
            custom_options[selectedOption.id] = selectedOption.features;
            renderHotspotsAndGlosary(custom_options);
            jQuery(`#features${selectedOption.id}`).removeClass("d-none");
          }

          const intervalLoad = setInterval(function () {
            if (
              document.querySelector(
                `#features${selectedOption.id} .viewRoomScheme`
              ).height > 0
            ) {
              clearInterval(intervalLoad);
              var $draggable = jQuery(".schemeSelectorPanel").draggabilly({
                containment: ".wrapper-page-hotspots",
                handle: ".card-header-accordion",
              });
              $draggable.on("dragEnd", function (event, pointer, moveVector) {
                if (event.pointerType === "mouse") {
                  jQuery(".card-header-accordion").click();
                }
              });
              options_logical.optionsAndChoices.init();
              options_logical.optionsAndChoices.setHotspotPosition();
            }
          }, 500);
        } else {
          jQuery("#pageoptionsandchoices-select").hide();
          jQuery("#error-msg").append(`<p>${data.message}`);
        }
      }
    });
  };

  const getFirstPage = (params) => {
    getOptionsAndChoices(params).then((data) => {
      if (data) {
        jQuery("#pageoptionsandchoices .list-loader").hide();

        if (data.status === "success") {
          let optionsChoices = data.data;
          optionsChoices.dataType = `${optionsChoices.dataType}s`;

          jQuery("body").append(
            `<input type="hidden" data-id="optionsAndChoicesSetId" value="${optionsChoices.id}">`
          );

          let isSubmitted = checkSubmitted(optionsChoices.showChoicesSubmitted);
          let isStyle = checkStyle(optionsChoices.dataType);
          let salesConfirmed = checkSalesConfirmed(optionsChoices.salesConfirmed);

          if (isSubmitted) {
            if (!salesConfirmed) {
              jQuery(".show-notification").show();
            } else {
              jQuery("#show-choices-submitted").show();
            }
          } else {
            jQuery(".show-notification").show();
          }

          if (isStyle) {
            if (isSubmitted) {
              jQuery("#set-style").hide();
            } else {
              jQuery("#set-style").show();
            }
            let selectedStyle = {};
            optionsChoices[optionsChoices.dataType].forEach((style) => {
              custom_styles[style.id] = style.schemes;

              jQuery(".optionsStyleSelect.styles .row").append(`
                  <div class="col-md-4">
                      <div class="custom-control custom-radio">
                      <label class="form--radio">
                          <input id="style${style.id}" type="radio" name="styleID" value="${style.id}"><span class="checkmark"></span>${style.title}
                      </label>
                      </div>
                  </div>
              `);

              addListenToStyle(style.id);
              checkOptionsExist(style.schemes, style.id);
              if (style.selected)
                selectedStyle = { schemes: style.schemes, id: style.id };
            });

            changeStyleSelected(selectedStyle.id);
            jQuery("#style" + selectedStyle.id).prop("checked", true);
          } else {
            checkOptionsExist(
              optionsChoices[optionsChoices.dataType],
              "schemes"
            );
          }
          jQuery(".confirm_btn").attr("href", optionsChoices.confirmBtnAction);
          jQuery(".draft_btn").attr(
            "href",
            optionsChoices.saveAsDraftBtnAction
          );
        } else {
          jQuery("#pageoptionsandchoices").hide();
          jQuery("#error-msg").append(`<p>${data.message}`);
        }
      }
    });
  };

  const addListenToBtn = (el) => {
    jQuery(el).bind("click keyup", (ev) => {
      if ((ev.keyCode === 13 && ev.type === "keyup") || ev.type === "click") {
        ev.preventDefault();
        const actionBtn = ev.currentTarget.getAttribute("data-action");
        let urlBtn = new URL(`https://example.com${actionBtn}`);

        let sitecode = document.querySelector(
          '[data-id="optionsAndChoicesSiteCode"]'
        ).value;
        let plotcode = document.querySelector(
          '[data-id="optionsAndChoicesPlotCode"]'
        ).value;
        let setId = document.querySelector(
          '[data-id="optionsAndChoicesSetId"]'
        ).value;

        // TODO to test on click if pageMode param exist

        if (urlBtn.searchParams.get("pageMode")) {
          let previewMode = "";
          if (urlBtn.searchParams.get("pageMode")) {
            previewMode =
              previewMode + `&pageMode=${urlBtn.searchParams.get("pageMode")}`;
          }
          if (urlBtn.searchParams.get("setid")) {
            previewMode =
              previewMode + `&setid=${urlBtn.searchParams.get("setid")}`;
          }
          if (urlBtn.searchParams.get("settype")) {
            previewMode =
              previewMode + `&settype=${urlBtn.searchParams.get("settype")}`;
            if (urlBtn.searchParams.get("settype") === "style") {
              let styleId = jQuery("input[name='styleID']:checked").val();
              previewMode = previewMode + `&styleSetId=${setId}`;
              previewMode = previewMode + `&styleId=${styleId}`;
            } else {
              previewMode = previewMode + `&categorySetId=${setId}`;
            }
          }
          if (urlBtn.searchParams.get("schemeId")) {
            previewMode =
              previewMode + `&schemeId=${urlBtn.searchParams.get("schemeId")}`;
          }
          window.location =
            window.location.origin +
            window.location.pathname +
            `?sitecode=${sitecode}&plotcode=${plotcode}${previewMode}`;
        } else {
          let type = urlBtn.searchParams.get("settype");
          let schemeId = urlBtn.searchParams.get("schemeId");

          if (type == "style") {
            let styleId = jQuery("input[name='styleID']:checked").val();
            window.location =
              window.location.origin +
              window.location.pathname +
              `?sitecode=${sitecode}&plotcode=${plotcode}&schemeId=${schemeId}&settype=${type}&styleSetId=${setId}&styleId=${styleId}`;
          } else {
            window.location =
              window.location.origin +
              window.location.pathname +
              `?sitecode=${sitecode}&plotcode=${plotcode}&schemeId=${schemeId}&settype=${type}&categorySetId=${setId}`;
          }
        }
      }
    });
  };

  const getParamsFromUrl = (href = location.href) => {
    let url = new URL(href);
    let params = new URLSearchParams(url.search.slice(1));
    let previewParams = {};
    if (params.get("pageMode")) {
      previewParams.pageMode = params.get("pageMode");
      if (params.get("setid")) {
        previewParams.schemeId = params.get("setid");
      }
      if (params.get("settype")) {
        previewParams.type = params.get("settype");
      }
    }

    let domParams = getParamsFromDomAndMerge(previewParams);

    if (params.has("schemeId")) {
      jQuery("#pageoptionsandchoices-select").show();
      let schemeId = params.get("schemeId");
      let type = params.get("settype");

      getViewData(domParams, schemeId, type);
    } else {
      jQuery("#pageoptionsandchoices").show();
      getFirstPage(domParams);
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    jQuery(document).ready(function () {
      getParamsFromUrl();

      jQuery(".wrapper-options").append("<div class='list-loader'></div>");

      jQuery(".backActionUrl").click((e) => {
        let urlBackBtn = new URL(e.currentTarget.href);
        e.preventDefault();
        let sitecode = document.querySelector(
          '[data-id="optionsAndChoicesSiteCode"]'
        ).value;
        let plotcode = document.querySelector(
          '[data-id="optionsAndChoicesPlotCode"]'
        ).value;

        if (urlBackBtn.searchParams.get("pageMode")) {
          let previewMode = "";
          if (urlBackBtn.searchParams.get("pageMode")) {
            previewMode =
              previewMode +
              `&pageMode=${urlBackBtn.searchParams.get("pageMode")}`;
          }
          if (urlBackBtn.searchParams.get("setid")) {
            previewMode =
              previewMode + `&setid=${urlBackBtn.searchParams.get("setid")}`;
          }
          if (urlBackBtn.searchParams.get("settype")) {
            previewMode =
              previewMode +
              `&settype=${urlBackBtn.searchParams.get("settype")}`;
          }
          if (urlBackBtn.searchParams.get("schemeId")) {
            previewMode =
              previewMode +
              `&schemeId=${urlBackBtn.searchParams.get("schemeId")}`;
          }
          window.location =
            window.location.origin +
            window.location.pathname +
            `?sitecode=${sitecode}&plotcode=${plotcode}${previewMode}`;
        } else {
          window.location =
            window.location.origin +
            window.location.pathname +
            `?sitecode=${sitecode}&plotcode=${plotcode}`;
        }
      });

      options_logical.optionsAndChoices = (function (a) {
        function checkInstanceTooltip(elem) {
          return jQuery(elem).tooltip("instance");
        }
        function closeTooltip(elementTooltip) {
          if (checkInstanceTooltip(elementTooltip)) {
            a(elementTooltip).tooltip("close");
          }
        }
        function openTooltip(elementTooltip) {
          if (checkInstanceTooltip(elementTooltip)) {
            a(elementTooltip).tooltip("open");
          }
        }
        function destroyTooltip(elementTooltip) {
          if (checkInstanceTooltip(elementTooltip)) {
            a(elementTooltip).tooltip("destroy");
          }
        }
        function preparePosition(elementHotspot) {
          let positionOptions = {};
          switch (a(elementHotspot).attr("data-position")) {
            case "top":
              positionOptions.classes = { "ui-tooltip": "arrowbottom" };
              positionOptions.my = "center bottom";
              positionOptions.at = "center top-15px";
              break;
            case "left":
              positionOptions.classes = { "ui-tooltip": "arrowright" };
              positionOptions.my = "right center";
              positionOptions.at = "left-15px center";
              break;
            case "right":
              positionOptions.classes = { "ui-tooltip": "arrowleft" };
              positionOptions.my = "left center";
              positionOptions.at = "right+15px center";
              break;
            default:
              positionOptions.classes = { "ui-tooltip": "arrowtop" };
              positionOptions.my = "center top";
              positionOptions.at = "center bottom+15px";
          }
          return positionOptions;
        }
        function initTooltipHotspot(elementHotspot) {
          let positionOptions = preparePosition(elementHotspot);

          a(elementHotspot).tooltip({
            items: "[data-position]",
            classes: positionOptions.classes,
            content: function () {
              var b = a(elementHotspot);
              return b.next(".captionHotSpot").html();
            },
            hide: false,
            show: false,
            position: {
              my: positionOptions.my,
              at: positionOptions.at,
              collision: "flip",
              within: ".viewRoomScheme:visible",
            },
          });
        }
        function showTooltip(elementHotspot) {
          initTooltipHotspot(elementHotspot);
          openTooltip(elementHotspot);
        }

        function rerenderAllEvents() {
          a(".hotSpot").unbind();
          a(".hotSpot").off();
          if (window.matchMedia("(min-width: 1281px)").matches) {
            y = true;
          } else {
            y = false;
          }
          if (y) {
            a(".hotSpot").hover(
              function (e) {
                showTooltip(a(this));
              },
              function (e) {
                destroyTooltip(a(this));
              }
            );
            a(".hotSpot").on("keyup", function (e) {
              showTooltip(a(this));
            });
            a(".hotSpot").blur(function (e) {
              destroyTooltip(a(this));
            });
          }

          const isTablets = ( window.matchMedia("(min-width: 801px)").matches &&
          window.matchMedia("(max-width: 1281px)").matches) || ( window.matchMedia("(min-width: 752px)").matches &&
          window.matchMedia("(max-width: 1281px)").matches && window.orientation === 0);

            if (isTablets) {
            a(".hotSpot").on("click", function (e) {
              let currentTooltip = jQuery(e.target);

              if (!checkInstanceTooltip(currentTooltip)) {
                showTooltip(jQuery(currentTooltip));
              }
            });
            a(".hotSpot").on("blur", function (e) {
              let currentTooltip = jQuery(e.target);

              if (checkInstanceTooltip(currentTooltip)) {
                destroyTooltip(jQuery(currentTooltip));
              }
            });
          }
        }
        function b() {
          a(".mhpOptions .optionsStyleSelect:not(.styles) label").bind(
            "click keyup",
            function (b) {
              if (
                (b.keyCode === 13 && b.type === "keyup") ||
                b.type === "click"
              ) {
                b.preventDefault(b);
                var d = a(this).closest("div").find("input:radio");
                a(".mhpOptions .optionsStyleSelect input:radio").each(
                  function () {
                    a(this).val() !== d.val() ? ((this.checked = !1),
                        a(`#option${a(this).val()}`).prop(
                          "checked",
                          this.checked
                        ),
                        a(this).attr("data-opt-selected", false),
                        a(this).parent().find("span > span").remove(),
                        a("#features" + a(this).val()).addClass("d-none"))
                      : ((this.checked = !0),
                        a(this).attr("data-opt-selected", true),
                        a(`#option${a(this).val()}`).prop(
                          "checked",
                          this.checked
                        ),
                        a(this)
                          .parent()
                          .find("span")
                          .append('<span class="checked-option"></span>'),
                        a("#features" + a(this).val()).removeClass("d-none"),
                        c());
                  }
                );
              }
            }
          );
        }
        function c() {
          a(".hotSpot").each(function () {
            var b = a(this).closest(".viewImage").find(".viewRoomScheme"),
              c = b.width(),
              d = b.height();
            a(this).css({
              left: Math.min((c * a(this).data("x")) / 100, c - 50) + "px",
              top: Math.min((d * a(this).data("y")) / 100, d - 50) + "px",
              visibility: "visible",
            });
          });
          rerenderAllEvents();
        }
        return { init: b, setHotspotPosition: c };
      })(jQuery);

      jQuery(window).on("load", function () {
        window.addEventListener(
          "resize",
          function () {
            options_logical.optionsAndChoices.setHotspotPosition();
          }
        ),
        windowUtils.addOrientationListener(function () {
          options_logical.optionsAndChoices.setHotspotPosition();
        });
      });

      jQuery(".confirm_btn, .draft_btn").click((e) => submitSelection(e));
      jQuery(
        "#pageoptionsandchoices-select .viewRoomStyles .button.button--theme"
      ).click((e) => submitOptions(e));
      jQuery(".schemeSelectorPanel .minus").attr("tabindex", 0);
      jQuery(".schemeSelectorPanel .plus").attr("tabindex", 0);
      jQuery(".schemeSelectorPanel .dropdownicon").on("keyup", (evt) => {
        if (evt.keyCode === 13 && evt.type === "keyup") {
          evt.preventDefault();
          jQuery(".card-header-accordion").click();
        }
      });
    });
    windowUtils.addOrientationListener(() => {
      blurHotspots();
    });
  });
}

function blurHotspots() {
  if (document.getElementById("pageoptionsandchoices-select")) {
    if (jQuery("#pageoptionsandchoices-select").css("display") === "block") {
      jQuery(".hotSpot").blur();
    }
  }
}

window.addEventListener("scroll", () => {
  blurHotspots();
});

window.addEventListener("visibilitychange", () => {
  blurHotspots();
});
